import infoTW from './InfoTW';
import infoCS from './InfoCS';
import DataStore from '../../DataStore';
import { infoType } from '../../../interface/IFooter';
import { makeEl } from '../../../common/Utils';
import infoRUTl from './InfoRU_TL';
import infoRUWTl from './InfoRU_W_TL';

export default class infoSG_TL {
  private ds: DataStore;

  constructor(_wrapper: HTMLElement, _csInfoType: infoType) {
    this.ds = DataStore.instance;


    _wrapper.classList.add('footer-info-sg-tl');
    // 등급 wrap
    const infoInnerWrap = makeEl('div', _wrapper, {class: 'info-inner-wrap-twru'})

    // 등급 Top
    const infoInnerTW_Wrap = makeEl('div', infoInnerWrap)

    // 등금 Bot
    const infoInnerRUs_Wrap =  makeEl('div', infoInnerWrap, {class: 'info-inner-wrap-ru-s'})
    const infoInnerRU_Wrap = makeEl('div', infoInnerRUs_Wrap)
    const infoInnerRU_W_Wrap = makeEl('div', infoInnerRUs_Wrap)

    
    // CS
    const infoInnerCSWrap = makeEl('div', _wrapper, {class: 'info-inner-wrap-cs'})
    
    // TW 15+
    new infoTW(infoInnerTW_Wrap);
    
    // RU 16+
    new infoRUTl(infoInnerRU_Wrap);
        
    // RU 16+ - White
    new infoRUWTl(infoInnerRU_W_Wrap);
    
    // CS
    new infoCS(infoInnerCSWrap, _csInfoType);
  }

  templ(_parent: HTMLElement, _data: string, _infoType: infoType) {
   
  }
}
